import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Landing Page Components
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Stats from './components/Stats';
import Demo from './components/Demo';
import UserFeedback from './components/UserFeedback';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

// Quiz Components
import QuizList from './components/QuizList';
import Quiz from './components/Quiz';
import QuizResults from './components/QuizResults';
import QuizResultHistory from './components/QuizResultHistory';

// Survey Component
import Survey from './components/Survey';

// User Settings Component
import UserSettings from './components/UserSettings';

// Terms and Privacy Policy Component
import TermsAndPrivacy from './components/TermsAndPrivacy';

// Login Component
import Login from './components/Login';

// Article Feedback Component
import ArticleFeedback from './components/reading/ArticleFeedback';

// PrepLetters Component
import PrepLetters from './components/PrepLetters';

// Bug Report Component
import BugReport from './components/BugReport';

// Learn Page Component (public)
import LearnPage from './components/LearnPage';

// Styles
import './styles/Quiz.css';

// Main App Component
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Landing Page Route */}
          <Route path="/" element={
            <>
              <Header />
              <Hero />
              <Features />
              <Stats />
              <Demo />
              <UserFeedback />
              <FAQ />
              <Footer />
            </>
          } />
          
          {/* Quiz Routes */}
          <Route path="/quizzes" element={
            <>
              <Header />
              <QuizList />
              <Footer />
            </>
          } />
          
          {/* Daily Quiz Route - must come before the general quiz route */}
          <Route path="/quiz/daily/:letterId" element={
            <>
              <Header />
              <Quiz />
              <Footer />
            </>
          } />
          
          {/* Regular Quiz Route */}
          {/* Daily Quiz Route - must come before the general quiz route */}
          <Route path="/quiz/daily/:letterId" element={
            <>
              <Header />
              <Quiz />
              <Footer />
            </>
          } />
          
          {/* Regular Quiz Route */}
          <Route path="/quiz/:quizId" element={
            <>
              <Header />
              <Quiz />
              <Footer />
            </>
          } />

          {/* Survey Route */}
          <Route path="/survey" element={
            <>
              <Header />
              <Survey />
              <Footer />
            </>
          } />

          {/* Quiz Results Route */}
          <Route path="/quiz-results/:quizId" element={
            <>
              <Header />
              <QuizResults />
              <Footer />
            </>
          } />
          
          {/* Quiz Result History Route */}
          <Route path="/quiz-history/:quizId" element={
            <>
              <Header />
              <QuizResultHistory />
              <Footer />
            </>
          } />
          
          {/* User Settings Route */}
          <Route path="/settings" element={
            <>
              <Header />
              <UserSettings />
              <Footer />
            </>
          } />
          
          {/* Login Route */}
          <Route path="/login" element={
            <>
              <Header />
              <Login />
              <Footer />
            </>
          } />
          
          {/* Article Feedback Route */}
          <Route path="/feedback/:articleId" element={
            <>
              <Header />
              <ArticleFeedback />
              <Footer />
            </>
          } />
          
          {/* PrepLetters Route */}
          <Route path="/prepletters" element={
            <>
              <Header />
              <PrepLetters />
              <Footer />
            </>
          } />

          {/* Public Learn Routes (no auth required) */}
          <Route path="/learn" element={
            <>
              <Header />
              <LearnPage />
              <Footer />
            </>
          } />
          <Route path="/learn/:letterId" element={
            <>
              <Header />
              <LearnPage />
              <Footer />
            </>
          } />
          
          {/* Terms and Privacy Policy Route */}
          <Route path="/terms-privacy" element={
            <>
              <Header />
              <TermsAndPrivacy />
              <Footer />
            </>
          } />
          
          {/* Bug Report Route */}
          <Route path="/bug-report" element={
            <>
              <Header />
              <BugReport />
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
